/* Lazy homepage rows (2026-10-03). Placeholders rendered by sections/featured-collection.liquid
   carry data-fb-lazy-section="<section id>"; when one nears the viewport we fetch the full row via
   the Section Rendering API and swap it into its .shopify-section wrapper. Custom elements in the
   row (slider-component, product-form, variant-selects) upgrade on insertion; scripts that only
   ran at page load listen for the 'fb:section-loaded' event. On failure the placeholder's
   "View all" link stays as the fallback. */
(function () {
  var rows = document.querySelectorAll('[data-fb-lazy-section]');
  if (!rows.length) return;

  function load(el) {
    if (el.dataset.fbLoading) return;
    el.dataset.fbLoading = '1';
    var id = el.dataset.fbLazySection;
    var host = document.getElementById('shopify-section-' + id);
    fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.getElementById('shopify-section-' + id);
        // A response that is still a placeholder would loop forever; keep the fallback link instead.
        if (!host || !src || src.querySelector('[data-fb-lazy-section]')) throw new Error('bad section response');
        host.innerHTML = src.innerHTML;
        document.dispatchEvent(new CustomEvent('fb:section-loaded', { detail: { section: host } }));
      })
      .catch(function () { el.classList.add('fb-lazy-row--failed'); });
  }

  if (!('IntersectionObserver' in window)) { rows.forEach(load); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); load(e.target); }
    });
  }, { rootMargin: '1200px 0px' });
  rows.forEach(function (el) { io.observe(el); });
})();
